var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import React, { useContext } from "react";
import { Global } from "@emotion/react";
import { merge } from "lodash/fp";
import { themeContext } from "../contexts";
import { themeToCssCustomProps } from "../utils";
export default function ThemeProvider(_a) {
  var _b = _a,
    {
      theme,
      children
    } = _b,
    restProps = __objRest(_b, ["theme", "children"]);
  let {
    global,
    theme: parentTheme
  } = useContext(themeContext);
  let cssProps = themeToCssCustomProps(theme);
  let value = __spreadValues({
    theme: merge(parentTheme, theme),
    cssProps
  }, restProps);
  if (!global && typeof children !== "function") {
    console.warn("Children of a nested <ThemeProvider> must be inside a function.");
  }
  return /* @__PURE__ */React.createElement(React.Fragment, null, global && /* @__PURE__ */React.createElement(Global, {
    styles: {
      ":root": cssProps
    }
  }), /* @__PURE__ */React.createElement(themeContext.Provider, {
    value
  }, typeof children === "function" ? children(value) : children));
}